import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
      <h2>Introduction</h2>
        <p>
        I see a wide variety of clients with different situations and different backgrounds. Each may not know what steps to take to move forward but the one thing that unifies them all is a desire to change. We want to be smarter, to be a better employee, a better parent, a better partner or have a better relationship but there are times where that desire to be better turns into an inner critic. Instead of leading us to be better, it leads to anxiety, depression, a lack of self compassion and a feeling of unrest for where you are at in life. I want to help you create the change and the life you want while learning to deal with the critic.
        </p>
        <p>
        I hope to help you begin to make progress on whatever problem brought you in as soon as possible by immediately cultivating a sense of momentum. Whether you view your problem as a difficult relationship or something difficult that has happened to you, I want to help you understand whats going on and begin working towards a more desired path.
        </p>
        <p>
        The decision to seek help from a stranger and let them in on your pain is a difficult one. It would be an honor for me to work side by side with you to begin to create the life you want to live. If you feel like I would be a good fit for you please don't hesitate to reach out.
        </p>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
